import React from "react";
import {Card} from "../../../../../components/card/card.jsx";
import Button from "../../../../../components/button/button.jsx";

const AttendanceActionsCard = ({isSaving, onSave, onSaveAndAdd}) => (
    <Card>
        <Card.Body className="flex justify-end gap-2">
            <Button target="primary-outline" onClick={onSaveAndAdd} actionFeedbackType='save'>Salvar e adicionar novo</Button>
            <Button onClick={onSave} actionFeedbackType='save'>Salvar</Button>
        </Card.Body>
    </Card>
);

export default AttendanceActionsCard;